export default __webpack_public_path__ + "static/feedback-06ca7d06fbf9da2ea67a61db5b945428.png";